var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zj-login-page"},[_c('zj-startup',{attrs:{"percent":_vm.startup.percent,"msg":_vm.startup.msg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }